var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat d-flex"},[_c('userList'),_c('chatDetail'),_c('orderDetail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }